import React from 'react';
import styled from 'styled-components';

import { Text } from '@oneaudi/unified-web-components';
import {
  renderTextWithFootnotesReferencesV2,
  cleanupEmissionConsumptionMarkup,
} from '@oneaudi/feature-app-utils';
import { useLogger } from '../../context/Context';

interface Consumption {
  consumption?: string;
  emission?: string;
  co2Class?: string;
  dischargedCO2Class?: string;
  dischargedConsumption?: string;
}

interface ConsumptionAndEmissionProps {
  consumptionData: Consumption;
  carlineName: string;
}

const ConsumptionAndEmission: React.FC<ConsumptionAndEmissionProps> = ({
  consumptionData,
  carlineName,
}) => {
  const { consumption, emission, co2Class, dischargedCO2Class, dischargedConsumption } =
    consumptionData;

  const logger = useLogger();

  if (!consumption && !emission) {
    logger?.warn('No emission and consumption data for', carlineName);
    return null;
  }
  const fontSize = process.env.IS_LEGACY ? '2' : '3';

  return (
    <StyledTextWithFootnotes variant={{ type: 'copy', order: fontSize, style: 'short' }}>
      {consumption && (
        <>{renderTextWithFootnotesReferencesV2(cleanupEmissionConsumptionMarkup(consumption))}</>
      )}
      {emission && (
        <>
          {'; '}
          {renderTextWithFootnotesReferencesV2(cleanupEmissionConsumptionMarkup(emission))}
        </>
      )}
      {/* footnote for co2Class will be provided, then please use renderTextWithFootnoteReferencesV2 */}
      {co2Class && (
        <>
          {'; '}
          {renderTextWithFootnotesReferencesV2(cleanupEmissionConsumptionMarkup(co2Class))}
        </>
      )}
      {dischargedConsumption && (
        <>
          {'; '}
          {renderTextWithFootnotesReferencesV2(
            cleanupEmissionConsumptionMarkup(dischargedConsumption),
          )}
        </>
      )}
      {dischargedCO2Class && (
        <>
          {'; '}
          {renderTextWithFootnotesReferencesV2(
            cleanupEmissionConsumptionMarkup(dischargedCO2Class),
          )}
        </>
      )}
    </StyledTextWithFootnotes>
  );
};

export const StyledTextWithFootnotes = styled(Text)`
  > sup {
    vertical-align: baseline;
    position: relative;
    top: -1em;
  }
`;

export default ConsumptionAndEmission;
